// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"893d0c86","206":"cea508b3","301":"d5943f29","444":"d0bf2a76","453":"c1714151","587":"5f353f15","682":"b83a03a7","825":"ddab0b6f","968":"ff246cd7"}[chunkId] + ".chunk.js";
};